<template>
  <section class="pt-80 pb-40 about__join">
    <div class="container" data-aos="fade-up" :data-aos-delay="200">
      <div class="row y-gap-15 justify-center text-center">
        <div class="col-auto">
          <!----<div class="sectionTitle">
            <h2 class="sectionTitle__title mx-auto">
              <span>Join Us </span> on a Journey of Growth and Success
            </h2>
            <p class="sectionTitle__text mx-auto">
              Whether you’re here to learn or teach, Planning Force offers a
              space for growth, inspiration, and connection. Become a part of
              our vibrant community today!
            </p>
          </div>-->
          <div v-html="visionData ? visionData['why_choose_us'][currentLanguage] : ''"></div>
          
          <div class="d-flex justify-center align-items-center about__join-buttons flex-column flex-md-row">
            <router-link to="/join-us" class="button main-button main-button-1 d-inline-flex justify-center align-items-center rotate-svg">
              {{ $t('button1') }}
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                >
                  <path
                    d="M11.086 5.65692L7.136 1.70692C6.95384 1.51832 6.85305 1.26571 6.85533 1.00352C6.8576 0.741321 6.96277 0.490508 7.14818 0.3051C7.33359 0.119692 7.5844 0.0145233 7.8466 0.0122448C8.1088 0.00996641 8.3614 0.110761 8.55 0.292919L14.207 5.94992C14.3002 6.04257 14.3741 6.15273 14.4246 6.27407C14.4751 6.3954 14.501 6.52551 14.501 6.65692C14.501 6.78833 14.4751 6.91844 14.4246 7.03977C14.3741 7.16111 14.3002 7.27127 14.207 7.36392L8.55 13.0209C8.45775 13.1164 8.34741 13.1926 8.2254 13.245C8.1034 13.2974 7.97218 13.325 7.8394 13.3262C7.70662 13.3273 7.57494 13.302 7.45205 13.2517C7.32915 13.2015 7.2175 13.1272 7.12361 13.0333C7.02971 12.9394 6.95546 12.8278 6.90518 12.7049C6.8549 12.582 6.8296 12.4503 6.83075 12.3175C6.8319 12.1847 6.85949 12.0535 6.9119 11.9315C6.96431 11.8095 7.04049 11.6992 7.136 11.6069L11.086 7.65692H1.5C1.23478 7.65692 0.98043 7.55156 0.792893 7.36403C0.605357 7.17649 0.5 6.92214 0.5 6.65692C0.5 6.3917 0.605357 6.13735 0.792893 5.94981C0.98043 5.76228 1.23478 5.65692 1.5 5.65692H11.086Z"
                    fill="white"
                  />
                </svg>
              </span>
            </router-link>
            <router-link to="/courses" class="button main-button rotate-svg">
             {{ $t('button2') }}
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                >
                  <path
                    d="M11.086 5.65692L7.136 1.70692C6.95384 1.51832 6.85305 1.26571 6.85533 1.00352C6.8576 0.741321 6.96277 0.490508 7.14818 0.3051C7.33359 0.119692 7.5844 0.0145233 7.8466 0.0122448C8.1088 0.00996641 8.3614 0.110761 8.55 0.292919L14.207 5.94992C14.3002 6.04257 14.3741 6.15273 14.4246 6.27407C14.4751 6.3954 14.501 6.52551 14.501 6.65692C14.501 6.78833 14.4751 6.91844 14.4246 7.03977C14.3741 7.16111 14.3002 7.27127 14.207 7.36392L8.55 13.0209C8.45775 13.1164 8.34741 13.1926 8.2254 13.245C8.1034 13.2974 7.97218 13.325 7.8394 13.3262C7.70662 13.3273 7.57494 13.302 7.45205 13.2517C7.32915 13.2015 7.2175 13.1272 7.12361 13.0333C7.02971 12.9394 6.95546 12.8278 6.90518 12.7049C6.8549 12.582 6.8296 12.4503 6.83075 12.3175C6.8319 12.1847 6.85949 12.0535 6.9119 11.9315C6.96431 11.8095 7.04049 11.6992 7.136 11.6069L11.086 7.65692H1.5C1.23478 7.65692 0.98043 7.55156 0.792893 7.36403C0.605357 7.17649 0.5 6.92214 0.5 6.65692C0.5 6.3917 0.605357 6.13735 0.792893 5.94981C0.98043 5.76228 1.23478 5.65692 1.5 5.65692H11.086Z"
                    fill="white"
                  />
                </svg>
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import AOS from "aos";
export default {
  computed:{
    ...mapGetters(["currentLanguage"]),
    visionData (){
      return this.$store.getters.landingSettings
    }
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
